export default function loadScriptAsync(src) {
  return new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve({ added: false, success: true })
      return
    }

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = src
    script.async = true

    script.onload = () => resolve({ added: true, success: true })
    script.onerror = () => {
      console.log(`Error loading async script ${src}`)
      resolve({ success: false })
    }

    document.head.appendChild(script)
  })
}
